import { NamedError } from '../../../utils/Errors';

export enum FileUploadForegroundTaskErrors {
    UnsupportedFileFormat = 'UnsupportedFileFormat',
    OneDriveUploadCanceled = 'OneDriveUploadCanceled',
    FileExceedsSizeLimit = 'FileExceedsSizeLimit',
    RecoveryFlowFileExceedsSizeLimit = 'RecoveryFlowFileExceedsSizeLimit',
    InvalidEmptyFile = 'InvalidEmptyFile',
    InvalidFileNameForOneDriveFileUpload = 'InvalidFileNameForOneDriveFileUpload',
    FileDecodeError = 'FileDecodeError',
    FileNotExist = 'FileNotExist',
    DeletedTranscript = 'DeletedTranscript'
}

export class FileUploadForegroundTaskError extends NamedError<FileUploadForegroundTaskErrors> {}